import { ValidationAbstract } from '@rehau/shared/forms/validations/validation.abstract';

export class OfferStatusChangeValidation extends ValidationAbstract {
  constructor() {
    super({ isOfferStatusEnum: undefined });
  }
}
